import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  card: {
    position: 'relative',
    padding: '15px 40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    borderRadius: 5,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    marginBottom: 20,
  },
  enabledContainer: {
    color: '#f8b100 ',
    marginBottom: -20,
    '& span': {
      fontSize: 15,
      fontWeight: '600',
      fontFamily: 'Averta Bold',
      color: '#f8b100 !important',
    },
  },
  mondayCheck:{
    fontSize: '1rem',
    fontFamily: 'Averta,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    fontWeight: '400',
    lineHeight: '1.5',
  },
  disabledContainer: {
    color: '#d6d6d6',
    marginBottom: -20,
    '& span': {
      fontSize: 15,
      fontWeight: '600',
      fontFamily: 'Averta Bold',
    },
  },
  mailCheck: {
    display: 'flex',
    gap: '2',
    flexDirection: 'row',
  },
  select: {
    fontFamily: 'Averta Light',
    '& > div': {
      border: 'solid 1px #707070',
    },
    '& > div:first-child > div': {
      padding: '0 0 0 10px',
    },
    '& > div:first-child > div > div': {
      padding: '8px 4px',
    },
    '& svg': {
      fill: '#f8b100',
    },
  },
  infoContainer: {
    margin: '1rem 0',
  },
  info: {
    margin: '0.5rem',
    fontSize: '14px',
  },
  infoDesc: {
    marginLeft: '0.5rem',
  },
  checkbox: {
    marginLeft: '0.5rem',
    '& svg': {
      fill: '#f8b100',
    },
    '& hover': {
      background: '#f8b1001a',
    },
  },
  grayText: {
    color: '#777575',
  },
  blackText: {
    color: '#000000',
  },
  loaderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '15px',
  },
  loader: {
    width: '25 !important',
    height: '25 !important',
    color: '#f8b100',
  },
  popup: {
    // position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: '#000000aa',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
  },

  popupCard: {
    width: '700px',
    position: 'relative',
    padding: 40,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    borderRadius: 5,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  },
  yesBtn: {
    color: '#ffffff',
    background: '#007FFF',
    marginRight: 10,
    padding: 2,
    '&:hover': {
      color: '#ffffff',
      background: '#007FFF',
    },
  },
  noBtn: {
    color: '#ffffff',
    background: '#FF0000',
    marginRight: 10,
    padding: 2,
    '&:hover': {
      color: '#ffffff',
      background: '#FF0000',
    },
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '14px',
    marginBottom: 10,
  },
  input: {
    fontFamily: 'Averta Light',
    width: '100%',
    height: 38,
    backgroundColor: '#fff',
    borderRadius: 5,
    justifyContent: 'center',
    border: 'solid 1px #707070',
    marginTop: '0.5rem',
    '& input': {
      padding: '5px 10px',
      fontFamily: 'Averta Light',
    },
    '& > div': {
      fontSize: 13,
    },
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& button': {
      color: '#ffffff',
      background: '#f8b100',
      '&:hover': { color: '#ffffff', background: '#f8b100' },
    },
  },
});
